import React from 'react';
import { Box, TextField } from '@mui/material';

type Hardware = {
    id: number;
    oui?: string;
    hclass?: string;
    DisplayName: string;
    manufacturer?: string;
    version?: string;
    protocol?: string;
};

interface Props {
  value: Hardware;
  onChange: (v: Hardware) => void;
}

export default function HardwareForm({ value, onChange }: Props) {
  return (
    <Box sx={{ mt: 1 }}>
      <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
        <Box>
          <TextField fullWidth label="Display Name" value={value.DisplayName || ''} onChange={(e) => onChange({ ...value, DisplayName: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="OUI" value={value.oui || ''} onChange={(e) => onChange({ ...value, oui: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Class" value={value.hclass || ''} onChange={(e) => onChange({ ...value, hclass: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Manufacturer" value={value.manufacturer || ''} onChange={(e) => onChange({ ...value, manufacturer: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Version" value={value.version || ''} onChange={(e) => onChange({ ...value, version: e.target.value })} />
        </Box>
        <Box>
          <TextField fullWidth label="Protocol" value={value.protocol || ''} onChange={(e) => onChange({ ...value, protocol: e.target.value })} />
        </Box>
      </Box>
    </Box>
  );
}
